import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import moment from 'moment'

// ** Async Thunks for Statement Data
export const fetchAllStatementData = createAsyncThunk(
  'statements/fetchAllStatementData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get('/vt/transaction/statementcardwise', {
        params: {
          ...params, 
          dateFrom: `${moment(params['dateFrom']).format("YYYY-MM-DD")}T00:00:00.000Z`, 
          dateTo: `${moment(params['dateTo']).format("YYYY-MM-DD")}T23:59:59.999Z`
        }
      })
      return {
        data: response.data.data,
        summary: response.data.aggregateData,
        allData: response.data.allData,
        totalPages: response.data.data.count
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch all statement data')
    }
  }
)

export const fetchStatementData = createAsyncThunk(
  'statements/fetchStatementData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get('users/statement', {
        params: {
          ...params, 
          dateFrom: `${params['dateFrom']}T00:00:00.000Z`, 
          dateTo: `${params['dateTo']}T23:59:59.999Z`
        }
      })
      return {
        statementData: response.data.data
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch statement data')
    }
  }
)

export const fetchMethodSummary = createAsyncThunk(
  'statements/fetchMethodSummary',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get('users/methodsummary', {
        params: {
          ...params, 
          dateFrom: `${params['dateFrom']}T00:00:00.000Z`, 
          dateTo: `${params['dateTo']}T23:59:59.999Z`
        }
      })
      return {
        methodSummary: response.data.data
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch method summary')
    }
  }
)

export const fetchChargebackSummary = createAsyncThunk(
  'statements/fetchChargebackSummary',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get('users/chargebacksummary', {
        params: {
          ...params, 
          dateFrom: `${params['dateFrom']}T00:00:00.000Z`, 
          dateTo: `${params['dateTo']}T23:59:59.999Z`
        }
      })
      return {
        chargebackSummary: response.data.data
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch chargeback summary')
    }
  }
)

export const fetchChargebackSummaryForLowRisk = createAsyncThunk(
  'statements/fetchChargebackSummaryForLowRisk',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get('users/chargebacksummaryforlowrisk', {
        params: {
          ...params, 
          dateFrom: `${params['dateFrom']}T00:00:00.000Z`, 
          dateTo: `${params['dateTo']}T23:59:59.999Z`
        }
      })
      return {
        chargebackSummaryForLowRisk: response.data.data
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch chargeback summary for low risk')
    }
  }
)

export const fetchRefundSummary = createAsyncThunk(
  'statements/fetchRefundSummary',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get('users/refundsummary', {
        params: {
          ...params, 
          dateFrom: `${params['dateFrom']}T00:00:00.000Z`, 
          dateTo: `${params['dateTo']}T23:59:59.999Z`
        }
      })
      return {
        refundSummary: response.data.data
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch refund summary')
    }
  }
)

export const fetchSettlementSummary = createAsyncThunk(
  'statements/fetchSettlementSummary',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get('users/settlementsummary', {
        params: {
          ...params, 
          dateFrom: `${params['dateFrom']}T00:00:00.000Z`, 
          dateTo: `${params['dateTo']}T23:59:59.999Z`
        }
      })
      return {
        settlementSummary: response.data.data
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch settlement summary')
    }
  }
)

export const fetchAchReturnSummary = createAsyncThunk(
  'statements/fetchAchReturnSummary',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get('users/achreturnsummary', {
        params: {
          ...params, 
          dateFrom: `${params['dateFrom']}T00:00:00.000Z`, 
          dateTo: `${params['dateTo']}T23:59:59.999Z`
        }
      })
      return {
        achReturnSummary: response.data.data
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch ACH return summary')
    }
  }
)

export const fetchAchPaidOutSummary = createAsyncThunk(
  'statements/fetchAchPaidOutSummary',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get('users/achpaidoutsummary', {
        params: {
          ...params, 
          dateFrom: `${params['dateFrom']}T00:00:00.000Z`, 
          dateTo: `${params['dateTo']}T23:59:59.999Z`
        }
      })
      return {
        achPaidOutSummary: response.data.data
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch ACH paid out summary')
    }
  }
)

export const fetchGiftCardPaidOutSummary = createAsyncThunk(
  'statements/fetchGiftCardPaidOutSummary',
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.get('users/giftcardpaidoutsummary', {
        params: {
          ...params, 
          dateFrom: `${params['dateFrom']}T00:00:00.000Z`, 
          dateTo: `${params['dateTo']}T23:59:59.999Z`
        }
      })
      return {
        giftCardPaidOutSummary: response.data.data
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch gift card paid out summary')
    }
  }
)

// ** Batch API call for all statement data
export const fetchAllStatementDataBatch = createAsyncThunk(
  'statements/fetchAllStatementDataBatch',
  async (params, { dispatch, rejectWithValue }) => {
    try {
      // Dispatch all API calls in parallel
      const promises = [
        dispatch(fetchAllStatementData(params)),
        dispatch(fetchStatementData(params)),
        dispatch(fetchMethodSummary(params)),
        params.isRiskEnabled ? dispatch(fetchChargebackSummary(params)) : dispatch(fetchChargebackSummaryForLowRisk(params)),
        dispatch(fetchRefundSummary(params)),
        dispatch(fetchSettlementSummary(params)),
        dispatch(fetchAchReturnSummary(params)),
        dispatch(fetchAchPaidOutSummary(params)),
        dispatch(fetchGiftCardPaidOutSummary(params))
      ]

      // Wait for all API calls to complete
      const results = await Promise.allSettled(promises)
      
      // Check if any failed
      const failed = results.filter(result => result.status === 'rejected')
      if (failed.length > 0) {
        console.error('Some statement API calls failed:', failed)
        // Don't reject if some calls failed, just log them
      }

      return {
        success: true,
        completedAt: Date.now(),
        results: results.map((result, index) => ({
          api: ['allStatementData', 'statementData', 'methodSummary', 'chargebackSummary', 'refundSummary', 'settlementSummary', 'achReturnSummary', 'achPaidOutSummary', 'giftCardPaidOutSummary'][index],
          status: result.status,
          data: result.status === 'fulfilled' ? result.value.payload : null,
          error: result.status === 'rejected' ? result.reason : null
        }))
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch statement data batch')
    }
  }
)

// ** Initial State
const initialState = {
  // Statement data
  allStatementData: null,
  statementData: null,
  methodSummary: null,
  chargebackSummary: null,
  refundSummary: null,
  settlementSummary: null,
  achReturnSummary: null,
  achPaidOutSummary: null,
  giftCardPaidOutSummary: null,
  
  // Loading states for individual APIs
  loading: {
    allStatementData: false,
    statementData: false,
    methodSummary: false,
    chargebackSummary: false,
    refundSummary: false,
    settlementSummary: false,
    achReturnSummary: false,
    achPaidOutSummary: false,
    giftCardPaidOutSummary: false,
    batch: false // For batch loading
  },
  
  // Error states for individual APIs
  errors: {
    allStatementData: null,
    statementData: null,
    methodSummary: null,
    chargebackSummary: null,
    refundSummary: null,
    settlementSummary: null,
    achReturnSummary: null,
    achPaidOutSummary: null,
    giftCardPaidOutSummary: null,
    batch: null
  },
  
  // Filter and search state
  filters: {
    dateFrom: null,
    dateTo: null,
    dateRange: null,
    period: 'M', // D, W, M
    selectedProcessor: null,
    selectedMerchant: null
  },
  
  // Cache management
  cache: {
    lastFetched: null,
    cacheKey: null,
    isStale: false,
    cacheExpiry: 5 * 60 * 1000 // 5 minutes
  },
  
  // UI state
  ui: {
    isDownloadable: false,
    isEmailDialogOpen: false,
    isPaidOutDialogOpen: false,
    currentDateRange: null,
    userOptions: [],
    processorOptions: []
  },
  
  // Merchant settings
  merchantSettings: {
    ivr: false,
    GiftCardActive: false,
    CustomerTip: false,
    IsRiskEnabled: false
  },
  
  // Statistics
  statistics: {
    totalTransactions: 0,
    totalAmount: 0,
    successRate: 0,
    lastUpdated: null
  }
}

// ** Slice
const statementSlice = createSlice({
  name: 'statements',
  initialState,
  reducers: {
    // Filter management
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
      // Mark cache as stale when filters change
      state.cache.isStale = true
    },
    
    setDateRange: (state, action) => {
      const { dateFrom, dateTo, dateRange } = action.payload
      state.filters.dateFrom = dateFrom
      state.filters.dateTo = dateTo
      state.filters.dateRange = dateRange
      state.cache.isStale = true
    },
    
    setPeriod: (state, action) => {
      state.filters.period = action.payload
      state.cache.isStale = true
    },
    
    setSelectedProcessor: (state, action) => {
      state.filters.selectedProcessor = action.payload
      state.cache.isStale = true
    },
    
    setSelectedMerchant: (state, action) => {
      state.filters.selectedMerchant = action.payload
      state.cache.isStale = true
    },
    
    // UI management
    setDownloadable: (state, action) => {
      state.ui.isDownloadable = action.payload
    },
    
    setEmailDialogOpen: (state, action) => {
      state.ui.isEmailDialogOpen = action.payload
    },
    
    setPaidOutDialogOpen: (state, action) => {
      state.ui.isPaidOutDialogOpen = action.payload
    },
    
    setCurrentDateRange: (state, action) => {
      state.ui.currentDateRange = action.payload
    },
    
    setUserOptions: (state, action) => {
      state.ui.userOptions = action.payload
    },
    
    setProcessorOptions: (state, action) => {
      state.ui.processorOptions = action.payload
    },
    
    // Merchant settings
    setMerchantSettings: (state, action) => {
      state.merchantSettings = { ...state.merchantSettings, ...action.payload }
    },
    
    // Cache management
    markCacheStale: (state) => {
      state.cache.isStale = true
    },
    
    clearCache: (state) => {
      state.cache = {
        lastFetched: null,
        cacheKey: null,
        isStale: false,
        cacheExpiry: 5 * 60 * 1000
      }
    },
    
    // Error management
    clearError: (state, action) => {
      const api = action.payload
      if (api) {
        state.errors[api] = null
      } else {
        state.errors = {
          allStatementData: null,
          statementData: null,
          methodSummary: null,
          chargebackSummary: null,
          refundSummary: null,
          settlementSummary: null,
          achReturnSummary: null,
          achPaidOutSummary: null,
          giftCardPaidOutSummary: null,
          batch: null
        }
      }
    },
    
    // Reset state
    resetStatementState: () => initialState,
    
    // Statistics update
    updateStatistics: (state, action) => {
      state.statistics = { ...state.statistics, ...action.payload }
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch All Statement Data
      .addCase(fetchAllStatementData.pending, (state) => {
        state.loading.allStatementData = true
        state.errors.allStatementData = null
      })
      .addCase(fetchAllStatementData.fulfilled, (state, action) => {
        state.loading.allStatementData = false
        state.allStatementData = action.payload
        state.cache.lastFetched = Date.now()
        state.cache.isStale = false
      })
      .addCase(fetchAllStatementData.rejected, (state, action) => {
        state.loading.allStatementData = false
        state.errors.allStatementData = action.payload
      })
      
      // Fetch Statement Data
      .addCase(fetchStatementData.pending, (state) => {
        state.loading.statementData = true
        state.errors.statementData = null
      })
      .addCase(fetchStatementData.fulfilled, (state, action) => {
        state.loading.statementData = false
        state.statementData = action.payload
      })
      .addCase(fetchStatementData.rejected, (state, action) => {
        state.loading.statementData = false
        state.errors.statementData = action.payload
      })
      
      // Fetch Method Summary
      .addCase(fetchMethodSummary.pending, (state) => {
        state.loading.methodSummary = true
        state.errors.methodSummary = null
      })
      .addCase(fetchMethodSummary.fulfilled, (state, action) => {
        state.loading.methodSummary = false
        state.methodSummary = action.payload
      })
      .addCase(fetchMethodSummary.rejected, (state, action) => {
        state.loading.methodSummary = false
        state.errors.methodSummary = action.payload
      })
      
      // Fetch Chargeback Summary
      .addCase(fetchChargebackSummary.pending, (state) => {
        state.loading.chargebackSummary = true
        state.errors.chargebackSummary = null
      })
      .addCase(fetchChargebackSummary.fulfilled, (state, action) => {
        state.loading.chargebackSummary = false
        state.chargebackSummary = action.payload
      })
      .addCase(fetchChargebackSummary.rejected, (state, action) => {
        state.loading.chargebackSummary = false
        state.errors.chargebackSummary = action.payload
      })
      
      // Fetch Chargeback Summary For Low Risk
      .addCase(fetchChargebackSummaryForLowRisk.pending, (state) => {
        state.loading.chargebackSummary = true
        state.errors.chargebackSummary = null
      })
      .addCase(fetchChargebackSummaryForLowRisk.fulfilled, (state, action) => {
        state.loading.chargebackSummary = false
        state.chargebackSummary = action.payload
      })
      .addCase(fetchChargebackSummaryForLowRisk.rejected, (state, action) => {
        state.loading.chargebackSummary = false
        state.errors.chargebackSummary = action.payload
      })
      
      // Fetch Refund Summary
      .addCase(fetchRefundSummary.pending, (state) => {
        state.loading.refundSummary = true
        state.errors.refundSummary = null
      })
      .addCase(fetchRefundSummary.fulfilled, (state, action) => {
        state.loading.refundSummary = false
        state.refundSummary = action.payload
      })
      .addCase(fetchRefundSummary.rejected, (state, action) => {
        state.loading.refundSummary = false
        state.errors.refundSummary = action.payload
      })
      
      // Fetch Settlement Summary
      .addCase(fetchSettlementSummary.pending, (state) => {
        state.loading.settlementSummary = true
        state.errors.settlementSummary = null
      })
      .addCase(fetchSettlementSummary.fulfilled, (state, action) => {
        state.loading.settlementSummary = false
        state.settlementSummary = action.payload
      })
      .addCase(fetchSettlementSummary.rejected, (state, action) => {
        state.loading.settlementSummary = false
        state.errors.settlementSummary = action.payload
      })
      
      // Fetch ACH Return Summary
      .addCase(fetchAchReturnSummary.pending, (state) => {
        state.loading.achReturnSummary = true
        state.errors.achReturnSummary = null
      })
      .addCase(fetchAchReturnSummary.fulfilled, (state, action) => {
        state.loading.achReturnSummary = false
        state.achReturnSummary = action.payload
      })
      .addCase(fetchAchReturnSummary.rejected, (state, action) => {
        state.loading.achReturnSummary = false
        state.errors.achReturnSummary = action.payload
      })
      
      // Fetch ACH Paid Out Summary
      .addCase(fetchAchPaidOutSummary.pending, (state) => {
        state.loading.achPaidOutSummary = true
        state.errors.achPaidOutSummary = null
      })
      .addCase(fetchAchPaidOutSummary.fulfilled, (state, action) => {
        state.loading.achPaidOutSummary = false
        state.achPaidOutSummary = action.payload
      })
      .addCase(fetchAchPaidOutSummary.rejected, (state, action) => {
        state.loading.achPaidOutSummary = false
        state.errors.achPaidOutSummary = action.payload
      })
      
      // Fetch Gift Card Paid Out Summary
      .addCase(fetchGiftCardPaidOutSummary.pending, (state) => {
        state.loading.giftCardPaidOutSummary = true
        state.errors.giftCardPaidOutSummary = null
      })
      .addCase(fetchGiftCardPaidOutSummary.fulfilled, (state, action) => {
        state.loading.giftCardPaidOutSummary = false
        state.giftCardPaidOutSummary = action.payload
      })
      .addCase(fetchGiftCardPaidOutSummary.rejected, (state, action) => {
        state.loading.giftCardPaidOutSummary = false
        state.errors.giftCardPaidOutSummary = action.payload
      })
      
      // Fetch All Statement Data Batch
      .addCase(fetchAllStatementDataBatch.pending, (state) => {
        state.loading.batch = true
        state.errors.batch = null
        // Set all individual loading states to true
        Object.keys(state.loading).forEach(key => {
          if (key !== 'batch') {
            state.loading[key] = true
          }
        })
      })
      .addCase(fetchAllStatementDataBatch.fulfilled, (state, action) => {
        state.loading.batch = false
        state.errors.batch = null
        state.cache.lastFetched = Date.now()
        state.cache.isStale = false
        
        // Process results
        action.payload.results.forEach(result => {
          if (result.status === 'fulfilled' && result.data) {
            switch (result.api) {
              case 'allStatementData':
                state.allStatementData = result.data
                state.loading.allStatementData = false
                break
              case 'statementData':
                state.statementData = result.data
                state.loading.statementData = false
                break
              case 'methodSummary':
                state.methodSummary = result.data
                state.loading.methodSummary = false
                break
              case 'chargebackSummary':
                state.chargebackSummary = result.data
                state.loading.chargebackSummary = false
                break
              case 'refundSummary':
                state.refundSummary = result.data
                state.loading.refundSummary = false
                break
              case 'settlementSummary':
                state.settlementSummary = result.data
                state.loading.settlementSummary = false
                break
              case 'achReturnSummary':
                state.achReturnSummary = result.data
                state.loading.achReturnSummary = false
                break
              case 'achPaidOutSummary':
                state.achPaidOutSummary = result.data
                state.loading.achPaidOutSummary = false
                break
              case 'giftCardPaidOutSummary':
                state.giftCardPaidOutSummary = result.data
                state.loading.giftCardPaidOutSummary = false
                break
            }
          } else if (result.status === 'rejected') {
            // Set error for failed API
            switch (result.api) {
              case 'allStatementData':
                state.errors.allStatementData = result.error
                state.loading.allStatementData = false
                break
              case 'statementData':
                state.errors.statementData = result.error
                state.loading.statementData = false
                break
              case 'methodSummary':
                state.errors.methodSummary = result.error
                state.loading.methodSummary = false
                break
              case 'chargebackSummary':
                state.errors.chargebackSummary = result.error
                state.loading.chargebackSummary = false
                break
              case 'refundSummary':
                state.errors.refundSummary = result.error
                state.loading.refundSummary = false
                break
              case 'settlementSummary':
                state.errors.settlementSummary = result.error
                state.loading.settlementSummary = false
                break
              case 'achReturnSummary':
                state.errors.achReturnSummary = result.error
                state.loading.achReturnSummary = false
                break
              case 'achPaidOutSummary':
                state.errors.achPaidOutSummary = result.error
                state.loading.achPaidOutSummary = false
                break
              case 'giftCardPaidOutSummary':
                state.errors.giftCardPaidOutSummary = result.error
                state.loading.giftCardPaidOutSummary = false
                break
            }
          }
        })
      })
      .addCase(fetchAllStatementDataBatch.rejected, (state, action) => {
        state.loading.batch = false
        state.errors.batch = action.payload
        // Reset all loading states
        Object.keys(state.loading).forEach(key => {
          state.loading[key] = false
        })
      })
  }
})

export const {
  setFilters,
  setDateRange,
  setPeriod,
  setSelectedProcessor,
  setSelectedMerchant,
  setDownloadable,
  setEmailDialogOpen,
  setPaidOutDialogOpen,
  setCurrentDateRange,
  setUserOptions,
  setProcessorOptions,
  setMerchantSettings,
  markCacheStale,
  clearCache,
  clearError,
  resetStatementState,
  updateStatistics
} = statementSlice.actions

export default statementSlice.reducer
